import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Search() {
  const [searchParams] = useSearchParams();
  const q = searchParams.get("q") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { search: q } }).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [q]);

  return (
    <div className="pt-28 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="text-xs uppercase tracking-[0.3em] text-[#00f0ff]">Search</span>
        <h1 className="font-display text-5xl md:text-7xl uppercase leading-none mt-3">
          "<span className="bttf-text">{q}</span>"
        </h1>
        <p className="text-zinc-400 mt-3" data-testid="search-count">{loading ? "Searching..." : `${products.length} results`}</p>

        {!loading && products.length === 0 ? (
          <div className="py-24 text-center text-zinc-400">No products found. Try a brand like "Fuel" or a category like "tires".</div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-12">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
